export function dasherize(str) {
    if (str) {
        str = str.trim().toLowerCase();
        return str.split(' ').join('-');
    }
    return str;
}
